export default (categories) => {
  return { xPids: { newContent: '', oldContent: '' }, xAllowRefererAccess: false };
};
